// extracted by mini-css-extract-plugin
export default {"wrapper":"g1-z","play":"h1-z"};